import { c as _c } from "react/compiler-runtime";
import { Icon } from '@/app/components/icons';
import { IconMoodBad } from '@/app/components/icons/social/icon-mood-bad';
import { DEALER_EMPTY_STATE_DATA } from '@/app/components/sections/dealer/utils/dealer-constant';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
interface DealerEmptyStateProps {
  className?: string;
  title?: string;
  description?: string;
  fullScreen?: boolean;
}
export const DealerEmptyState = t0 => {
  const $ = _c(14);
  const {
    className,
    title,
    description,
    fullScreen: t1
  } = t0;
  const fullScreen = t1 === undefined ? false : t1;
  const t2 = !fullScreen;
  let t3;
  if ($[0] !== className || $[1] !== fullScreen || $[2] !== t2) {
    t3 = cn("flex flex-col items-center justify-center gap-y-4", {
      "py-10": t2,
      "bg-silver-100 h-full min-h-48 rounded-sm": fullScreen
    }, className);
    $[0] = className;
    $[1] = fullScreen;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: "dealer-not-found"
    });
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon className="text-red-500" size="2xl" icon={<IconMoodBad />} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = title || DEALER_EMPTY_STATE_DATA.TITLE;
  let t7;
  if ($[6] !== t6) {
    t7 = <p className="text-sub-h2 font-noto-bold">{t6}</p>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = description || DEALER_EMPTY_STATE_DATA.DESCRIPTION;
  let t9;
  if ($[8] !== t8) {
    t9 = <div className="text-body-2-fixed where-span:text-inline-wrap text-center text-gray-700" dangerouslySetInnerHTML={{
      __html: t8
    }} />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t3 || $[11] !== t7 || $[12] !== t9) {
    t10 = <div className={t3} {...t4}>{t5}{t7}{t9}</div>;
    $[10] = t3;
    $[11] = t7;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
};